import React, { useEffect, useState } from 'react';
import CustomSelect from "../../../components/UI/customSelect/customSelect";
import { Close, CopyIcon, LinkIcon } from "../../../icons/icons";
import CustomSelectCheckBox from "../../../components/UI/customSelectCheckBox/customSelectCheckBox";
import NewVisaTable from "../../../components/table/new-visa-table";
import CustomInput from "../../../components/UI/customInput/customInput";
import CustomButton from "../../../components/UI/customButton/customButton";
import { useTranslation } from "react-i18next";
import { Get, Post } from "../../../apis/api";
import { useSelector } from "react-redux";
import { toggleAuth } from "../../../store/user/user.reducer";
import { toast } from "react-toastify";
import LoadingFix from "../../../components/loading-fix/loading-fix";
import { Link, useLocation, useParams } from "react-router-dom";
import CrewTable from "../../../components/table/CrewTable/crew-table";
import { useVisaRegister } from './zustand';

const CrewStep = ({ changeStep, listOfCrew, activeStep }) => {


  const [idModal, setIdModal] = useState(false)
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [newData, setNewData] = useState([])
  const [nationality, setNationality] = useState([])

  const [visaList, setVisaList] = useState([])
  const [crewList, setCrewList] = useState([])
  const [crewListJob, setCrewListJob] = useState([])
  const [openCrewModal, setOpenCrewModal] = useState(false)
  const [form, setForm] = useState({});
  const location = useLocation();
  const selectedCrew = location.state?.crewList;
  const user = useSelector((state) => state.user.user)
  const pathname = window.location.hostname

  const { selectVisa, forward  , dispatch} = useVisaRegister()

  console.log({nationality})
  const handleList = () => {


    setLoading(true)
    Get(`agent/profile/crews`).then((res) => {
      console.log(res)
      setData(res?.data)
      setNationality(res?.nationality )
    }).finally(() => {
      setLoading(false)
    })

    Get(`agent/profile/visas`).then((res) => {
      setVisaList(res.details.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleCrewFromOtherPage = () => {
    if (selectedCrew && selectedCrew.length > 0) {
      const filteredCrew = data?.data?.filter(item =>
        selectedCrew.includes(item.id)
      )
      setNewData(filteredCrew)
      setCrewList(selectedCrew)
    }
  };

  useEffect(() => {
    if (selectedCrew?.length > 0) {
      handleCrewFromOtherPage()
    }
  }, [selectedCrew, data])



  const handleCrew = () => {
    const newList = []
    data?.data?.forEach((item) => {
      newList.push({ value: item.name + " " + item.last_name, id: item.id })
    })
    return newList
  }

  const handleVisa = () => {
    const newList = []
    visaList?.data?.filter(i => !i?.duplicate).forEach((item) => {
      newList.push({ fa_name: item?.fa_name, en_name: item?.en_name, id: item.id })
    })
    return newList
  }
  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }))
  }


  console.log({visaListData:visaList?.data})
  const handleSubmit = () => {


    if (crewList.length == 0) {
      return toast.error(t('NoCrewSelected'))
    }

    if(crewListJob.length!=crewList.length)
    {
      return toast.error(t('JobNotSelected'))
    }

    setLoading(true);
    Post("agent/visas/store", { ...form, "form": "store_form", crews: crewListJob, duplicate_visa_id: null })
      .then((res) => {
        const selectedVisa = visaList.data?.find(i => i.id == res.details?.data?.visa?.id)
        selectVisa(selectedVisa , res?.details)
        // forward()
        // changeStep(2)
        listOfCrew(crewList)
        localStorage.setItem("visaId", res.details?.data?.id)
      })
      .catch((error) => {
        toast.error(error.message || error.msg || error.data.message)

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelectCrewList = () => {
    const filteredArray = data?.data?.filter(item => crewList.includes(item.id))
    setNewData(filteredArray)
    localStorage.setItem("crewList", JSON.stringify(filteredArray))
    setOpenCrewModal(false)
  }


  const handleCrewList = (e) => {
    const newList = crewList
    const find = newList?.findIndex((item) => {
      return item === e
    })
    if (find !== -1) {
      newList.splice(find, 1)
    } else {
      newList.push(e)
    }
    setCrewList(newList)
  }
  const handleDeleteCrew = (e) => {
    const newList = crewList
    const newListJob = crewListJob
    const find = newList?.findIndex((item) => {
      return item === e
    })
    if (find !== -1) {
      newList.splice(find, 1)
    }
    const findJob = newListJob?.findIndex((item) => {
      return item.id === e
    })
    if (findJob !== -1) {
      newListJob.splice(findJob, 1)
    }
    setCrewList(newList)
    setCrewListJob(newListJob)
  }
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(t("linkIsCopy"))

    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  useEffect(() => {
    if (activeStep)
      handleList()
  }, [activeStep])


  const handleCrewJob = (newCrew) => {
    const prev = crewListJob?.find(item => item.id === newCrew.id);
    if (!prev) {
      setCrewListJob([...crewListJob, newCrew]);
    } else {
      setCrewListJob(crewListJob.map(item =>
        item.id === newCrew.id ? { ...item, job_id: newCrew.job_id } : item
      ));
    }
  };

  console.log({ selectedCrew })

  return (
    <div className={` ${activeStep ? "h-auto" : "h-0 overflow-hidden "}`}>
      {
        loading && <LoadingFix />
      }
      <div className={`my-container  bg-white rounded-lg  flex flex-col gap-9 w-full !mt-5  py-5 px-4 md:px-[13%] mb-8`}>
        <div className={"text-start text-gray-500"}>
          <div className={"text-sm md:text-base"}>
            {t("newVisaTitle")}
          </div>
          <div className={"text-sm md:text-base"}>
            {t("newVisaDes")}
          </div>
        </div>
        <div>
          <CustomSelect
            onchange={(e) => handleForm(e)}
            options={handleVisa()}
            placeHolder={"visaType"}
            label={"visaType"}
            name={"visa_id"}
          />
        </div>
        <div className={"flex flex-col md:flex-row w-full"}>
          <div className={"flex flex-col md:w-3/5"}>
            <div className={"text-xs text-gray-500"}>{t("createLinkTitle")}</div>
            <div className={"text-main mt-2 mb-9 md:mb-0 flex items-center "}>
              <span onClick={() => copyToClipboard(`https://${pathname}/crew/auth/register/${user?.referral_code}`)} className={"w-full  flex items-center justify-start cursor-pointer"}>
                <span className={"px-1"}>
                  <CopyIcon />
                </span>
                <span className={"text-gray-500 select-none"}>
                  {`https://${pathname}/crew/auth/register/${user?.referral_code}`}
                </span>
              </span>
              {/*<span  onClick={() => setIdModal(true)} className={"px-1 cursor-pointer"}>*/}
              {/*  {t("createLink")}*/}
              {/*</span>*/}
            </div>
          </div>
          <div className={"md:w-2/5"}>
            <div className={"w-full"}>
              <CustomButton loading={loading} onClick={() => setOpenCrewModal(true)} title={"crewName"} />
            </div>
          </div>
        </div>
      </div>
      <NewVisaTable onChange={(e) => {
        handleDeleteCrew(e)
        handleSelectCrewList()
      }} onchangeJob={(e) => handleCrewJob(e)} defaultValue={newData} nationality={nationality} />

      {newData?.length == 0 && <div className='bg-white  justify-center  my-container flex flex-row py-4 text-gray-500 text-sm'>{t('NoCrewSelected')}</div>}

      <div onClick={(e) => e.target === e.currentTarget && setOpenCrewModal(false)} className={`${openCrewModal ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0   items-center justify-center z-40`}>
        <div className={"flex flex-col justify-start bg-white p-5 max-h-[90%] w-[80%] overflow-y-scroll rounded-lg"}>
          <div className={"w-full flex flex-col gap-2"}>
            <CrewTable defaultValue={selectedCrew} order={true} onChange={(e) => handleCrewList(e)} />
          </div>
          <div className={"w-full mt-5"}>
            <CustomButton loading={loading} onClick={() => handleSelectCrewList()} title={"addNewCrew"} />
          </div>
        </div>

      </div>
      <div onClick={(e) => e.target === e.currentTarget && setIdModal(false)} className={`${idModal ? "flex" : "hidden"} bg-modal h-full w-full fixed top-0 right-0   items-center justify-center z-40`}>
        <div className={"bg-white rounded-2xl p-5 w-[350px]"}>
          <div className={"flex items-center mb-8 justify-between"}>
            <span className={'text-primary-400 text-base'}>
              {t("createLinkModal")}
            </span>
            <span onClick={() => setIdModal(false)} className={"cursor-pointer"}>
              <Close color={"#8A9098"} />
            </span>
          </div>

          <div
            className="relative  bg-white rounded-lg  flex flex-col items-center w-full  overflow-hidden ">
            <div className={"flex flex-col gap-5 w-full"}>

              <span className={"w-full"}>
                <CustomInput
                  placeHolder={t("crewEmail")}
                  label={t("crewEmail")}
                  name={"crewEmail"}
                />
              </span>
              <div className={"w-full"}>
                <CustomButton styles={"text-sm"} title={t("sendLink")} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={"flex justify-between my-container pt-10  items-center"}>
        <Link to={"/visa-orders"} className={"text-main cursor-pointer"}>{t("close")}</Link>
        <div className={"min-w-[330px]"}>
          <CustomButton disable={!form?.['visa_id']} loading={loading} onClick={() => handleSubmit()} title={"saveAndNext"} />
        </div>
      </div>
    </div>
  );
};

export default CrewStep;
